var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7583 15.4526H26.3864C20.3019 15.4526 15.3477 20.4146 15.3477 26.504V44.8872C15.3477 50.9766 20.3019 55.9386 26.3864 55.9386H44.7583C50.8428 55.9386 55.797 50.9766 55.797 44.8872V26.5337C55.797 20.4146 50.8428 15.4526 44.7583 15.4526ZM52.325 44.9169C52.325 49.1075 48.9418 52.4934 44.7583 52.4934H26.3864C22.2029 52.4934 18.7901 49.1075 18.7901 44.9169V26.5337C18.7901 22.3431 22.2029 18.9275 26.3864 18.9275H44.7583C48.9418 18.9275 52.325 22.3134 52.325 26.5337V44.9169Z",
    fill: "#38B6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0894 24.6311C49.0894 25.9958 47.9926 27.1269 46.5993 27.1269C45.2319 27.1269 44.1055 26.0255 44.1055 24.6311C44.1055 23.2664 45.2023 22.1353 46.5993 22.1353C47.9926 22.1649 49.0894 23.2664 49.0894 24.6311Z",
    fill: "#38B6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5554 25.4028C29.886 25.4028 25.2578 30.0385 25.2578 35.7088C25.2578 41.3829 29.886 46.0185 35.5554 46.0185C41.2249 46.0185 45.8531 41.3829 45.8531 35.7088C45.8531 30.0385 41.2545 25.4028 35.5554 25.4028ZM35.5554 42.5436C31.7869 42.5436 28.7299 39.4841 28.7299 35.7088C28.7299 31.9373 31.7869 28.8777 35.5554 28.8777C39.3239 28.8777 42.381 31.9373 42.381 35.7088C42.381 39.4841 39.3239 42.5436 35.5554 42.5436Z",
    fill: "#38B6FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_714_66397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 71
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.328125 0.45166H70.7625V70.9433H0.328125V0.45166Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_714_66397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5564 70.9656C16.147 70.9656 0.328125 55.1635 0.328125 35.7086C0.328125 16.2834 16.147 0.45166 35.5564 0.45166C54.9955 0.45166 70.7847 16.2834 70.7847 35.7086C70.7847 55.1635 54.9955 70.9656 35.5564 70.9656ZM35.5564 2.3838C17.1845 2.3838 2.2587 17.3255 2.2587 35.7086C2.2587 54.0955 17.1845 69.0371 35.5564 69.0371C53.9284 69.0371 68.8542 54.0955 68.8542 35.7086C68.8542 17.3255 53.9284 2.3838 35.5564 2.3838Z",
    fill: "#38B6FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramPortfolio);
export default __webpack_public_path__ + "static/media/Instagram-portfolio.3190bcafcf9a78e0fb78d9843db33982.svg";
export { ForwardRef as ReactComponent };